"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routerPathGroup = exports.apiPathGroup = exports.packageGroup = exports.subjectName = void 0;
exports.subjectName = 'Metadata';
exports.packageGroup = 'metadata';
exports.apiPathGroup = 'metadata';
exports.routerPathGroup = 'metadata';
